import React from "react";

import {
    Card,
    Typography
} from "antd";

const {
    Text
} = Typography;

const MessageBubble = ({
                           message
                       }) => {

    const seller =
        message?.senderType === "SELLER";

    return (
        <div
            style={{
                display: "flex",
                justifyContent: seller
                    ? "flex-end"
                    : "flex-start"
            }}
        >
            <Card
                style={{
                    maxWidth: "70%",
                    borderRadius: 18,
                    background: seller
                        ? "#1677ff"
                        : "#f5f5f5",
                    border: "none"
                }}
                bodyStyle={{
                    padding: 14
                }}
            >

                <Text
                    strong
                    style={{
                        color: seller
                            ? "#ffffff"
                            : "#1677ff"
                    }}
                >
                    {seller
                        ? "Vous"
                        : "Acheteur"
                    }
                </Text>

                <br />

                <Text
                    style={{
                        color: seller
                            ? "#ffffff"
                            : "#000000",
                        fontSize: 15
                    }}
                >
                    {message?.content || ""}
                </Text>

                <br />

                <Text
                    style={{
                        fontSize: 11,
                        color: seller
                            ? "#dbeafe"
                            : "#888"
                    }}
                >
                    {message?.createdAt
                        ? new Date(
                            message.createdAt
                        ).toLocaleString()
                        : ""
                    }
                </Text>

            </Card>
        </div>
    );
};

export default MessageBubble;